import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { useSearchParams } from "react-router-dom"

import { cn } from "@/lib/utils"

// urlTab: sekme seçimi adres çubuğundaki ?tab= değerinden gelir ve sekme çubuğu gizlenir
// (alt menü soldaki yan menüde gösterilir).
const UrlTabCtx = React.createContext(false)
const Tabs = React.forwardRef(({ urlTab, defaultValue, value, onValueChange, ...props }, ref) => {
  const [sp, setSp] = useSearchParams()
  if (!urlTab) {
    return (
      <UrlTabCtx.Provider value={false}>
        <TabsPrimitive.Root ref={ref} defaultValue={defaultValue} value={value} onValueChange={onValueChange} {...props} />
      </UrlTabCtx.Provider>
    )
  }
  return (
    <UrlTabCtx.Provider value={true}>
      <TabsPrimitive.Root ref={ref} value={sp.get("tab") || defaultValue}
        onValueChange={(v) => setSp({ tab: v }, { replace: true })} {...props} />
    </UrlTabCtx.Provider>
  )
})
Tabs.displayName = "Tabs"

const TabsList = React.forwardRef(({ className, ...props }, ref) => {
  const hidden = React.useContext(UrlTabCtx)
  if (hidden) return null
  return (
    <TabsPrimitive.List
      ref={ref}
      className={cn(
        "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
        className
      )}
      {...props} />
  )
})
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
